class Faqs {
    constructor(sel) {
        // view
        this.components = document.querySelectorAll(sel);

        if (this.components.length) {
            this.init();
        }
    }

    init() {
        this.components.forEach(comp => {
            this.initQuestions(comp);
        })
    }
    initQuestions(comp) {
        const questions = comp.querySelectorAll('.questions .question');
        questions.forEach(faq => {
            faq.setAttribute('style', `--heightContent:0px`);
            faq.addEventListener('click', () => {
                const isActive = faq.classList.contains('active');
                const content = faq.querySelector('.content-box');
                content.addEventListener('click', e => e.stopPropagation());
                if (!isActive) {
                    faq.classList.add('active');
                    const contentHeight = content.scrollHeight;
                    faq.setAttribute('style', `--heightContent:${contentHeight}px`);
                } else {
                    faq.classList.remove('active');
                    faq.setAttribute('style', `--heightContent:0px`);
                }
            });
        });
    }
}

const example = new Faqs(".faqs");
